module.exports = __webpack_public_path__ + "static/img/cc3f0f2573ab0732618dbccec321770.f096b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/cc3f0f2573ab0732618dbccec321770.png
// module id = i2+5
// module chunks = 0